import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Flex, Modal, Spin, Tooltip, Typography } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import _ from 'lodash'
import React, { useState } from 'react'
import { ContentPartFilter } from '../../../../components/content-part/ContentPartFilter'
import { PageHeader } from '../../../../components/page-header'
import { EmptyData } from '../../../../components/empty/emptyData'
import { useTranslation } from 'react-i18next'
import { useGetDataOnScroll } from '../../../../components/getDataOnScrollProps/useGetDataOnScrollProps'
import i18n from 'i18next'
import {
  useLazyGetFertilizerUsageListQuery,
  useReportFertilizerUsageMutation,
} from '../../../../redux/api/chemicalization/fertilizerUsage'
import { useFertilizerUsage } from './useFertilizerUsage'
import { FilterFertilizerUsage } from './FilterFertilizerUsage'
import { EntFertilizerUsage } from '../../../../models/chemicalization/fertilizerUsage'
import { EntFertilizerUsageFilter } from '../../../../models/filters/fertilizerUsageFilter'
import { AddFertilizerUsage } from './AddFertilizerUsage'
import ReportChemicalization from '../reportChemicalization/ReportChemicalization'

enum FormField {
  periodStart,
  periodEnd,
  cropTypeIds,
  territorialUnitIds,
}

export const FertilizerUsage = () => {
  const [modal, contextHolder] = Modal.useModal()
  const [selectedItem, setSelectedItem] = useState<EntFertilizerUsage>(new EntFertilizerUsage())
  const [showModal, setShowModal] = useState<boolean>(false)
  const [showReportModal, setShowReportModal] = useState<boolean>(false)
  const [form] = useForm()
  const { t } = useTranslation()

  const [getReportFertilizerUsage] = useReportFertilizerUsageMutation()
  const [getFertilizerUsage] = useLazyGetFertilizerUsageListQuery()
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage,
  } = useGetDataOnScroll<EntFertilizerUsage, EntFertilizerUsageFilter>({
	initialFilter: new EntFertilizerUsageFilter(),
	query: getFertilizerUsage,
  })

  const { onAddFertilizerUsage, onDeleteFertilizerUsage, onEditFertilizerUsage } =
	useFertilizerUsage(modal, () => {
	  searchHandleClick()
	})
  const [height, setHeight] = useState<number>(0)

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isChemAvailable = storedData.some((route: any) => (route.alias === "/departments/chemicalization/report" || route.alias === "/interactive-map-ws") && route.methodPost);


  const openAddModal = (item: EntFertilizerUsage) => {
	setSelectedItem(item)
	setShowModal(true)
  }

  const setEntityFromFields = (): EntFertilizerUsageFilter => {
	let filt: EntFertilizerUsageFilter = _.clone(filter)
	filt.periodStart = form.getFieldValue(FormField.periodStart)?.format('YYYY-MM-DD') ?? null
	filt.periodEnd = form.getFieldValue(FormField.periodEnd)?.format('YYYY-MM-DD') ?? null
	filt.cropTypeIds = form.getFieldValue(FormField.cropTypeIds) ?? null
	filt.territorialUnitIds = form.getFieldValue(FormField.territorialUnitIds) ?? null
	filt.page = 1
	return filt
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.periodStart, value: null },
	  { name: FormField.periodEnd, value: null },
	  { name: FormField.cropTypeIds, value: null },
	  { name: FormField.territorialUnitIds, value: null },
	])
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields())
	setData([])
	setCurrentPage(0)
	setFetching(true)
  }

  const getReport = async (payload: {
	periodStart: string
	periodEnd: string
	language: string
  }): Promise<Blob> => {
	return await getReportFertilizerUsage(payload).unwrap()
  }

  const openReportModal = () => {
	setShowReportModal(true)
  }

  const table = (
	<div
	  style={ { maxHeight: `${ height }px`, overflow: 'auto', maxWidth: 1500 } }
	  onScroll={ scrollHandler }
	>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: '40px' } }>#</th>
		  <th style={ { width: '150px' } }>{ t('titles.territorialUnitRegion') }</th>
		  <th style={ { width: '220px' } }>{ t('titles.territorialUnitDistricts') }</th>
		  <th style={ { width: '150px' } }>{ t('chemicalization.fertilizer_usage.crop_area') }</th>
		  <th style={ { width: '150px' } }>
			{ t('chemicalization.fertilizer_usage.fertilizer_area') }
		  </th>
		  <th style={ { width: '150px' } }>{ t('chemicalization.fertilizer_usage.percent') }</th>
		  <th>{ t('titles.crop_type') }</th>
		  <th style={ { width: '120px' } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<td colSpan={ 8 }>
			  <Spin
				spinning={ fetching }
				style={ {
				  width: '100%',
				  height: '180px',
				  display: 'flex',
				  alignItems: 'center',
				  justifyContent: 'center',
				} }
			  />
			</td>
		  </tr>
		) : null }
		{ data.length !== 0 ? (
		  data.map((item, index) => (
			<tr key={ item.id }>
			  <td>{ index + 1 }</td>
			  <td>
				{ i18n.language === 'ru'
				  ? item?.territorialUnitRegion?.nameRu
				  : item?.territorialUnitRegion?.nameKy }
			  </td>
			  <td>
				<div className='chem-detail'>
				  { item?.fertilizerUsageCrops?.map((district, dIndex) => (
					<React.Fragment key={ district.id || dIndex }>
					  { district.cropDetails?.map((detail, detailIndex) => {
						// Если это первая запись (detailIndex === 0), выводим название района
						if (detailIndex === 0) {
						  return (
							<div className='chem-district-block' key={ detailIndex }>
							  { i18n.language === 'ru'
								? district?.territorialUnitDistrict?.nameRu
								: district?.territorialUnitDistrict?.nameKy }
							</div>
						  )
						} else {
						  // Для всех последующих строк выводим пустой блок с отдельным классом
						  return <div className='chem-district-block-empty' key={ detailIndex }/>
						}
					  }) }
					</React.Fragment>
				  )) }
				</div>
			  </td>

			  <td>
				<div className='chem-detail'>
				  { item?.fertilizerUsageCrops?.map((district, dIndex) => (
					<div key={ district.id || dIndex }>
					  { district.cropDetails?.map((detail, index) => (
						<div key={ index } className='chem-district-block'>
						  { detail.cropArea }
						</div>
					  )) }
					</div>
				  )) }
				</div>
			  </td>
			  <td>
				<div className='chem-detail'>
				  { item?.fertilizerUsageCrops?.map((district, dIndex) => (
					<div key={ district.id || dIndex }>
					  { district.cropDetails?.map((detail, index) => (
						<div key={ index } className='chem-district-block'>
						  { detail.fertilizerArea }{ ' ' }
						</div>
					  )) }
					</div>
				  )) }
				</div>
			  </td>
			  <td>
				<div className='chem-detail'>
				  { item?.fertilizerUsageCrops?.map((district, dIndex) => (
					<div key={ district.id || dIndex }>
					  { district.cropDetails?.map((detail, index) => (
						<div key={ index } className='chem-district-block'>
						  { detail.percent != null ? Number(detail.percent).toFixed(3) : '' }
						</div>
					  )) }
					</div>
				  )) }
				</div>
			  </td>
			  <td>
				<div className='chem-detail'>
				  { item?.fertilizerUsageCrops?.map((district, dIndex) => (
					<div key={ district.id || dIndex }>
					  { district.cropDetails?.map((detail, index) => (
						<div key={ index } className='chem-district-block'>
						  { i18n.language === 'ru'
							? detail?.cropType?.nameRu
							: detail?.cropType?.nameKy }
						</div>
					  )) }
					</div>
				  )) }
				</div>
			  </td>
			  <td>
				<Flex gap='small'>
				  { access && access.methodPut && (
					<Tooltip title={ t('general.edit') }>
					  <Button
						className='btn_edit'
						onClick={ () => {
						  openAddModal(item)
						} }
						type='primary'
						shape='circle'
						icon={ <EditOutlined/> }
					  />
					</Tooltip>
				  ) }
				  { access && access.methodDelete && (
					<Tooltip title={ t('general.delete') }>
					  <Button
						className='btn_edit'
						danger
						onClick={ () => {
						  onDeleteFertilizerUsage(item)
						} }
						type='primary'
						shape='circle'
						icon={ <DeleteOutlined/> }
					  />
					</Tooltip>
				  ) }
				</Flex>
			  </td>
			</tr>
		  ))
		) : (
		  <tr>
			<td colSpan={ 8 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  )

  return (
	<>
	  <PageHeader
		title={ t('titles.fertilizer_usage') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type='secondary'>
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button
		  type='primary'
		  icon={ <PlusOutlined/> }
		  onClick={ () => {
			openAddModal(new EntFertilizerUsage())
		  } }
		>
		  { t('general.add') }
		</Button>
	  ) }
	  { isChemAvailable && (
		<Button
		  style={ { marginLeft: '5px' } }
		  type='primary'
		  icon={ <PlusOutlined/> }
		  onClick={ () => openReportModal() }
		>
		  { t('general.generate_report') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={
		  <FilterFertilizerUsage
			onSearch={ searchHandleClick }
			onReset={ () => {
			  clearFields()
			  searchHandleClick()
			} }
			formField={ FormField }
			form={ form }
		  />
		}
		setHeight={ setHeight }
		table={ table }
	  />
	  <AddFertilizerUsage
		fertilizerUsage={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id ? onEditFertilizerUsage : onAddFertilizerUsage }
	  />
	  <ReportChemicalization
		title={ t('reports.report_by_fertilizer_usage') }
		getReport={ getReport }
		show={ showReportModal }
		onHide={ () => setShowReportModal(false) }
	  />
	  { contextHolder }
	</>
  )
}
